import LINE_COLORS from './graphColors';

const graphColors = [
  '#8C46C3',
  '#C8427A',
  ...LINE_COLORS,
];

export default graphColors;
